var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#384336",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Essential Icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,28H20a3,3,0,0,1,0-6H80a3,3,0,0,1,0,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80,53H20a3,3,0,0,1,0-6H80a3,3,0,0,1,0,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80,78H20a3,3,0,0,1,0-6H80a3,3,0,0,1,0,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGreen);
export default __webpack_public_path__ + "static/media/menu-green.979c0a7bbb642a519d1f2e517ec7e163.svg";
export { ForwardRef as ReactComponent };